// @ngInject
function SubCategoriesApiService($q, DS, ResourcesService, DSHttpAdapter) {

    var endpoint = 'subcategories';

    return {
        getPage: getPage,
        getSubCategory: ResourcesService.apiFactory.get(endpoint),
        getMaingroups: ResourcesService.apiFactory.get(endpoint + '/maingroups'),
        getIntrastats: ResourcesService.apiFactory.get(endpoint + '/intrastats'),
        save:  ResourcesService.apiFactory.save(endpoint, 'SubCategory')
    };

    function getPage(page, pageSize, searchTerm) {

        var args = {
                params: {
                    page: page,
                    pageSize: pageSize,
                    searchTerm: searchTerm
                }
        };

        return ResourcesService.apiFactory.get(endpoint + '/page')(args);
    }

}

angular.module('subcategories.api', [])
  .factory('SubCategoriesApiService', SubCategoriesApiService);
